<template>
    <div v-show="value"  class="dialog">
      <transition name="dialog-bounce">
      <div class="html_dialog" :style="htmlDialog.wrap_css">
        <div class="close" @click="handleAction('confirm')">
        </div>
      </div>
      </transition>

      <div class="content" :style="htmlDialog.content_css" v-if="htmlDialog.content">
        <div v-html="htmlDialog.content"></div>
      </div>
    </div>
</template>
<script>
  import create from 'vant/lib/utils/create';
  import Popup from 'vant/lib/mixins/popup';

  export default create({
    name: 'HtmlDialog',
    mixins: [Popup],
    props: {
      callback: Function,
      overlay: {
        type: Boolean,
        default: true
      },
      closeOnClickOverlay: {
        type: Boolean,
        default: false
      },
      lockOnScroll: {
        type: Boolean,
        default: true
      },
      htmlDialog: {
        type: Object,
        default: function () {
          return {}
        }
      }
    },
    methods: {
      handleAction(action) {
        this.$emit('input', false);
        this.$emit(action);
        this.callback && this.callback(action);
      }
    }

  });
</script>


<style lang="stylus" scoped>
  @import "../../../share/mixins.styl"

  .dialog
    position fixed

  .html_dialog
    position: fixed;
    overflow: hidden;
    transition: 1s;
    border-radius: 4px;
    background-color: #fff;
    background-size cover
    background-repeat no-repeat

  .close
    position absolute
    top 0
    right 0
    width 1rem
    height @width

  .content
    overflow-y scroll
    position fixed


</style>



// WEBPACK FOOTER //
// src/components/Popups/HtmlDialog/HtmlDialog.vue